import {ApolloClient, createHttpLink, from, InMemoryCache} from '@apollo/client';
import {setContext} from '@apollo/client/link/context';
import { errorLink } from './errorLink';
import { getToken } from 'utils/auth';
import { getOrCreateDeviceId, getEndType } from 'utils/deviceId';

// 创建HTTP链接
const httpLink = createHttpLink({
    uri: '/api/graphql',
});

// 认证链接
const authLink = setContext((_, {headers}) => {
    // 获取本地存储的token
    const token = getToken();

    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : '',
            // F3 单会话：上送端类型与 deviceId，供后端 Web 单会话校验（endType 由后端 ClientDeviceInfo 解析）
            DeviceInfo: JSON.stringify({ deviceUUID: getOrCreateDeviceId(), endType: getEndType() }),
        },
    };
});

// 创建Apollo Client实例
export const client = new ApolloClient({
    link: from([errorLink, authLink, httpLink]),
    cache: new InMemoryCache(),
    defaultOptions: {
        watchQuery: {
            fetchPolicy: 'cache-and-network',
        },
    },
});
